import React from 'react';
import { Modal } from 'antd';
import ItemForm from './ItemForm';

const ItemModal = ({
  visible,
  onCancel,
  onSubmit,
  initialValues,
  title,
  departments = [],
  categories = [],
}) => {
  return (
    <Modal
      title={title || 'Add Item'}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      <ItemForm
        initialValues={initialValues}
        onSubmit={(values) => {
          onSubmit(values);
          onCancel();
        }}
        onCancel={onCancel}
        departments={departments}
        categories={categories}
      />
    </Modal>
  );
};

export default ItemModal;
